<template>
  <!-- eslint-disable -->
  <div>
    <!-- <formulario-filters /> -->
    <b-card>
      <validation-observer ref="movExterForm" #default="{ invalid }">
        <b-row>
          <b-col lg="2" order-sm="1" order-lg="1" class="mb-2 pr-0 text-start my-lg-auto">
            <b-button variant="danger" v-b-tooltip.hover.top="'Atras'" @click.prevent="back">
              <feather-icon icon="ArrowLeftIcon" class="mr-50" /> Atras
            </b-button>
          </b-col>
          <b-col lg="2" order-sm="2" order-lg="2" class="mb-md-0 mb-2">
            <b-form-group label="Tipo" label-for="action_type">
              <validation-provider #default="{ errors }" name="form.action_type" vid="action_type" rules="requeridoE">
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="Types"
                  label="name"
                  v-model="form.action_type"
                  :reduce="(Types) => Types.val"
                  input-id="action_type"
                  @input="typeAction(form.action_type)"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col lg="3" order-sm="3" order-lg="3" class="mb-md-0 mb-2">
            <b-form-group label="Tipo Documento" label-for="tipo">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="tipoCompro"
                label="text"
                :reduce="(tipoCompro) => tipoCompro.val"
                input-id="tipo"
                v-model="form.document_type"
              />
            </b-form-group>
          </b-col>
          <b-col lg="3" order-sm="4" order-lg="4"  class="mb-md-0 mb-2">
            <b-form-group label="Tienda Origen" label-for="storeSelected">
              <validation-provider
                #default="{ errors }"
                name="form.storeSelected"
                vid="storeSelected"
                rules="requeridoE"
              >
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="locals"
                  label="name"
                  v-model="form.storeSelected"
                  :reduce="(locals) => locals.id"
                  input-id="storeSelected"
                  @input="searchMov(form.storeSelected)"
                  disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col lg="2" order-sm="7" order-lg="5" class="text-left mb-2 text-lg-right my-lg-auto" v-if="items.length > 0">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success" @click.prevent="updateMov">
              Actualizar
            </b-button>
          </b-col>
          <b-col lg="6" order-sm="5" order-lg="6" class="my-auto">
            <b-form-group label="Descripción">
              <validation-provider
                #default="{ errors }"
                name="form.documentDescription"
                vid="documentDescription"
                rules="requeridoE"
              >
                <b-form-textarea
                  id="description"
                  placeholder="Descripción"
                  resize
                  autofocus
                  trim
                  v-model="form.documentDescription"
                  rows="1"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col lg="6" order-sm="6" order-lg="7" class="my-auto">
            <b-form-group label="Extra Descripción">
              <validation-provider
                #default="{ errors }"
                name="form.extendedDescription"
                vid="extradescription"
                rules="requeridoE"
              >
                <b-form-textarea
                  id="extradescription"
                  placeholder="Extra Descripción"
                  resize
                  autofocus
                  trim
                  v-model="form.extendedDescription"
                  rows="1"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-card no-body class="mb-1" v-if="items.length > 0">
          <b-row>
            <b-col lg="12" class="">
              <b-table
                class="position-relative border border-2 rounded mt-2"
                :hover="true"
                :items="items"
                responsive
                :fields="fieldsItems"
                show-empty
                empty-text="No existen"
                @sort-changed="sortChanged"
              >
                <template v-slot:cell(qty)="{ item, field: { key } }">
                  <b-input-group>
                    <validation-provider
                      #default="{ errors }"
                      name="form.cantidad"
                      vid="form.cantidad"
                      rules="requeridoE"
                    >
                      <b-form-input
                        v-model="item[key]"
                        style="width: 150px"
                        type="number"
                        @keypress="onlyNumbers($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-input-group>
                </template>
                <template v-slot:cell(price)="{ item, field: { key } }">
                  <b-input-group>
                    <validation-provider #default="{ errors }" name="form.price" vid="form.price" rules="requeridoE">
                      <b-form-input
                        v-model="item[key]"
                        style="width: 150px"
                        type="number"
                        @keypress="onlyNumbers($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-input-group>
                </template>
                <template #cell(actions)="data">
                  <b-button
                    @click="selectItem(data, data.item, false)"
                    size="sm"
                    class=""
                    v-b-tooltip.hover.top="'Eliminar'"
                    variant="flat-danger"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
        <b-card no-body class="mb-0">
          <b-table
            class="position-relative border border-2 rounded"
            :hover="true"
            :items="records"
            responsive
            :fields="fields"
            show-empty
            empty-text="No existen"
            @sort-changed="sortChanged"
            :head-variant="'dark'"
            ref="table"
          >
            <template #cell(precio)="data">
              {{ '$' + data.value }}
            </template>
            <template #cell(actions)="data">
              <b-form-checkbox
                v-model="data.item.value"
                class="vs-checkbox-con"
                @change="selectItem(data, data.item, data.item.value)"
              >
              </b-form-checkbox>
            </template>
            <!-- Column: Actions -->
            <!-- <template #cell(actions)="data">
          <b-button size="sm" class="" v-b-tooltip.hover.top="'Detalle'" variant="flat-success">
            <feather-icon icon="EyeIcon" />
          </b-button>
        </template> -->
            <!-- <template #cell(actions)="data">
            <b-form-checkbox v-model="data.item.value" class="vs-checkbox-con" @change="selectItem(data.item, data.value)">
            </b-form-checkbox>
          </template> -->
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col sm="3">
                <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                  <b-form-select
                    v-model="showEntrie"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="entries"
                    @change="changeSizePage"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="3" class="mt-75" style="font-size: 12px">
                <span> {{ totalElements }} Registros en total</span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalElements"
                  :per-page="showEntrie"
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @change="cambioPagina"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, requeridoE, email } from '@validations'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import StoreService from '@/services/StoresService'
import AutoPartsService from '@/services/AutoParts'
import StockService from '@/services/StockService'
import ExternalMovement from '@/services/ExternalMovement'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      required,
      showLoading: false,
      form: {
        document_type: '',
        documentDescription: '',
        extendedDescription: '',
        storeSelected: null,
        action_type: '',
        details: [],
        detailsEliminated: []
      },
      locals: [],
      tipoCompro: [
        {
          id: 1,
          text: 'Boleta',
          val: 'boleta'
        },
        {
          id: 2,
          text: 'Factura',
          val: 'factura'
        },
        {
          id: 3,
          text: 'Guia Remision',
          val: 'guia_remision'
        },
        {
          id: 4,
          text: 'Nota de Credito',
          val: 'nota_credito'
        },
        {
          id: 5,
          text: 'Devolución',
          val: 'devolucion'
        },
        {
          id: 6,
          text: 'Ninguno',
          val: ''
        }
      ],
      records: [],
      auxItems: [],
      Types: [
        {
          id: 1,
          name: 'Compra',
          val: 'purchase'
        },
        {
          id: 2,
          name: 'Rebaja',
          val: 'sale'
        },
        {
          id: 3,
          name: 'Prestamo',
          val: 'lending'
        },
        {
          id: 4,
          name: 'Credito',
          val: 'credit'
        },
        {
          id: 5,
          name: 'Reembolso',
          val: 'refund'
        }
      ],
      fields: [
        // { key: 'id', label: 'Nº', sortable: false },
        { key: 'autopart.uniqueCode', label: 'Código Único', sortable: true },
        { key: 'originalCode', label: 'Codigo Original', sortable: true },
        { key: 'alterCode', label: 'Codigo Alter.', sortable: true },
        { key: 'description', label: 'Descripción', sortable: false },
        { key: 'autopartBrand.name', label: 'Marca', sortable: true },
        { key: 'vehicleModel.model', label: 'Vehiculo', sortable: true },
        // { key: 'retailPrice', label: 'Precio x Menor (US$)', sortable: false },
        // { key: 'wholesalePrice', label: 'Precio x Mayor (US$)', sortable: false },
        { key: 'actions', label: 'Seleccionar' }
      ],
      fieldsItems: [
  
        { key: 'autopart.originalCode', label: 'Código', sortable: false },
        { key: 'qty', label: 'Cantidad', sortable: false },
        { key: 'price', label: 'Precio', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      items: [],
      cont: 1,
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      idStore: null,
      sort: 'id',
      order: 'desc'
    }
  },
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver
  },
  mounted() {
    this.getData()
  },
  methods: {
    back() {
      this.$store.commit('back/setIndexTabME', 1)
      this.$router.push('/inventario/salida')
    },
    async updateMov() {
      this.isDisabled = true
      this.form.details = []
      console.log('this.auxItems', this.auxItems)
      for (let index = 0; index < this.items.length; index++) {
        const element = this.items[index]
        const index1 = this.auxItems.findIndex((elemento) => elemento.autopart.id == element.autopart.id)
        if (index1 >= 0) {
          this.form.details.push({
            autopart: this.auxItems[index1].autopart.id,
            id: this.auxItems[index1].id,
            qty: parseInt(element.qty)
          })
        } else {
          this.form.details.push({
            autopart: element.autopart.id,
            qty: parseInt(element.qty),
            price: parseFloat(element.price)
          })
        }
      }
      console.log('this.form', this.form)
      const resp = await ExternalMovement.updateMov(this.$route.params.id, this.form, this.$store)
      console.log('resp', resp)
      if (resp) {
        this.$swal({
          title: 'Actualizado',
          text: 'El movimiento ha sido actualizado',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
        this.isDisabled = false
        this.getData()
        this.reloadSelectedItemsInGrid()
      }
    },
    async getData() {
      const resp = await StoreService.getStores('', this.$store)
      if (resp) {
        this.locals = resp.stores
      }
      //Trae la data del movimiento a editar
      const getMov = await ExternalMovement.getMovExternal(this.$route.params.id, this.$store)
      console.log('getmov exter', getMov)
      if (getMov) {
        this.searchMov(getMov.movement.storeSelected.id)
        this.form.document_type = getMov.movement.document_type
        this.form.documentDescription = getMov.movement.documentDescription
        this.form.extendedDescription = getMov.movement.extendedDescription
        this.form.storeSelected = getMov.movement.storeSelected.id
        for (let index = 0; index < getMov.detail.length; index++) {
          const element = getMov.detail[index]
          element.value = false
          this.items[index] = element
          this.auxItems[index] = element
          this.items[index].value = true
        }
      }
      this.reloadSelectedItemsInGrid()
    },
    resetForm() {
      this.items = []
      this.form = {
        document_type: '',
        documentDescription: '',
        extendedDescription: '',
        storeSelected: null,
        action_type: '',
        details: []
      }
      this.records = []
      this.$refs.movExterForm.reset()
    },
    // register() {
    //   this.$refs.movExterForm.validate().then(async (success) => {
    //     this.form.details = []
    //     for (let index = 0; index < this.items.length; index++) {
    //       const element = this.items[index]
    //       this.form.details.push({
    //         autopart: element.id,
    //         qty: element.cantidad
    //       })
    //     }
    //     console.log('this.form', this.form)
    //     const resp = await ExternalMovement.saveMovements(this.form, this.$store)
    //     console.log('resp', resp)
    //     if (resp) {
    //       this.$swal({
    //         title: 'Añadido',
    //         text: 'El movimiento ha sido registrado',
    //         icon: 'success',
    //         customClass: {
    //           confirmButton: 'btn btn-primary'
    //         },
    //         buttonsStyling: false
    //       })
    //       this.isDisabled = false
    //       this.resetForm()
    //     }
    //   })
    // },
    cambioPagina(e) {
      this.currentPage = e
      if (this.form.action_type != 'purchase') {
        this.searchMov(this.idStore)
      } else {
        this.action_type(this.form.action_type)
      }
    },
    onlyNumbers(e) {
      if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 46) {
        return true
      } else {
        e.preventDefault()
      }
    },
    selectItem(data, item, val) {
      if (val == true) {
        item.autopart = {
          id: item.id,
          name: item.name,
          originalCode: item.originalCode
        }
        this.items.push(item)
        var id1 = item.id
        if (item.autopart) {
          id1 = item.autopart.id
        }
        let encontrados = []
        const index1 = this.auxItems.findIndex((e) => e.autopart.id == id1)
        console.log('index1', index1)
        if (index1 >= 0) {
          encontrados = this.auxItems.filter((e) => e.autopart.id == id1)
          console.log('encontrados', encontrados)
          const index = this.form.detailsEliminated.findIndex((elemento) => elemento.id == encontrados[0].id)
          console.log('index asdf', index)
          if (index >= 0) {
            this.form.detailsEliminated.pop(encontrados[0].id)
          }
        }

        // this.form.detailsEliminated.pop(item.id)
        console.log('this.form.detailsEliminated en check', this.form.detailsEliminated)
      } else {
        console.log('item no check', item)
        console.log('this.records nocheck', this.records)
        console.log('this.auxItems no check', this.auxItems)
        var id = item.id
        if (item.autopart) {
          id = item.autopart.id
        }
        const index = this.records.findIndex((elemento) => elemento.id == id)
        console.log('index', index)
        if (index >= 0) {
          this.records[index].value = false
          this.items = this.items.filter((elemento) => elemento.autopart.id !== id)
        }
        //Verificar elementos eliminados
        let eliminados = []
        console.log('this.auxItems asd', this.auxItems)
        console.log('id asd', id)
        eliminados = this.auxItems.filter((e) => e.autopart.id == id)
        if (eliminados.length > 0) {
          console.log('ELEMENTO ENCONTRADO EN DATA TRAIDA DE SERVICIO')
          //Verificar que elemento eliminado no sea repetido
          if (this.form.detailsEliminated.length > 0) {
            let idnotrepeat = eliminados[0].autopart.id
            console.log('idnotrepeat', idnotrepeat)
            let notrepeat = this.form.detailsEliminated.indexOf(idnotrepeat)
            if (notrepeat == -1) {
              this.form.detailsEliminated.push({ id: eliminados[0].id })
            }
          } else {
            this.form.detailsEliminated.push({ id: eliminados[0].id })
          }
        }
        console.log('this.form.detailsEliminated', this.form.detailsEliminated)
      }
      console.log('this.items', this.items)
    },
    async typeAction(tipo) {
      if (tipo == 'purchase') {
        this.records = []
        let offset = this.showEntrie * (this.currentPage - 1)
        const url = `?limit=${this.showEntrie}&offset=${offset}`
        const resp = await AutoPartsService.getAutoParts(url, this.$store)
        if (resp.autoparts.length != 0) {
          this.totalElements = resp.itemCount
          for (let index = 0; index < resp.autoparts.length; index++) {
            const element = resp.autoparts[index]
            this.records[index] = element
          }
          this.$refs.table.refresh()
        }
      }
    },
    async searchMov(id) {
      if (this.form.action_type != 'purchase') {
        this.idStore = id
        console.log('entra aquiiiii')
        this.records = []
        let offset = this.showEntrie * (this.currentPage - 1)
        const url = `?limit=${this.showEntrie}&offset=${offset}&filter=${id}`
        const resp = await StockService.getMovements(url, this.$store)
        console.log('resp de tienda', resp)
        if (resp.stocks.length != 0) {
          this.totalElements = resp.itemCount
          for (let index = 0; index < resp.stocks.length; index++) {
            const element = resp.stocks[index]
            this.records[index] = element.autopart
          }
          this.$refs.table.refresh()
        }
        console.log('this.records asdasdasd', this.records)
      }
    },
    async reloadSelectedItemsInGrid() {
      //logica de seleccionar a los items dentro del grid
      await new Promise((r) => setTimeout(r, 500))
      for (let i = 0; i < this.items.length; i++) {
        const index = this.records.findIndex((elemento) => elemento.id == this.items[i].autopart.id)
        console.log('index', index)
        if (index >= 0) {
          this.records[index].value = true
        }
      }
    },
    changeSizePage() {
      if (this.form.action_type != 'purchase') {
        this.searchMov(this.idStore)
      } else {
        this.action_type(this.form.action_type)
      }
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
